import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { CompanyStore } from '../../features/company-context/store/company.store';
import { AuthService } from '../services/auth.service';
import { readCompanyKeyFromPathFromRoot } from '../routing/company-route.util';

async function resolveCompanyRoute(
  route: { pathFromRoot: ReadonlyArray<{ paramMap: { get(name: string): string | null } }> },
  router: Router,
  companyStore: CompanyStore,
  auth: AuthService
): Promise<boolean | ReturnType<Router['createUrlTree']>> {
  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/auth/login']);
  }

  const routeCompanyKey = readCompanyKeyFromPathFromRoot(route);
  if (!routeCompanyKey) {
    return router.createUrlTree(['/auth/login']);
  }

  const result = await companyStore.resolveFromRouteKey(routeCompanyKey);
  if (result === 'ok') {
    return true;
  }

  const reason = result === 'not-found' ? 'not-found' : result === 'forbidden' ? 'forbidden' : 'error';
  return router.createUrlTree(['/company-context'], { queryParams: { reason } });
}

export const companyRouteGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const companyStore = inject(CompanyStore);
  const auth = inject(AuthService);
  return resolveCompanyRoute(route, router, companyStore, auth);
};

export const companyRouteChildGuard: CanActivateChildFn = async (childRoute) => {
  const router = inject(Router);
  const companyStore = inject(CompanyStore);
  const auth = inject(AuthService);
  return resolveCompanyRoute(childRoute, router, companyStore, auth);
};
